var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortbyWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.3,
    height: 20.02,
    viewBox: "0 0 14.3 20.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sortby",
    transform: "translate(-6 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9057",
    "data-name": "Path 9057",
    d: "M6.715,10.14h12.87a.715.715,0,0,0,.66-.457.759.759,0,0,0-.155-.806l-6.435-6.66a.7.7,0,0,0-1.011,0L6.21,8.877a.759.759,0,0,0-.155.806.715.715,0,0,0,.66.457Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9058",
    "data-name": "Path 9058",
    d: "M19.585,19H6.715a.715.715,0,0,0-.66.457.759.759,0,0,0,.155.806l6.435,6.66a.7.7,0,0,0,1.011,0l6.435-6.66a.759.759,0,0,0,.155-.806A.715.715,0,0,0,19.585,19Z",
    transform: "translate(0 -5.12)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortbyWhite);
export default __webpack_public_path__ + "static/media/sortby-white.35bf6e859fbae0c1e1aee8b52b701ad1.svg";
export { ForwardRef as ReactComponent };